import { FireflyTargetHighlightHost } from "@/components/activity/firefly/FireflyTargetHighlightHost";
import { FireflyTourSessionLayer } from "@/components/activity/FireflyTourSessionLayer";
import { FireflyDiscoveryTourOffer } from "@/components/activity/FireflyDiscoveryTourOffer";
import type { PrimaryMode } from "@/components/lead/sections/LeadWorkspaceHeaderAccess";
import {
  buildFireflyTourRequestEventDetail,
  emitFireflyTourRequestEvent,
} from "@/lib/firefly/fireflyTourRequestEvent";
import type { useLeadWorkspaceShellFirefly } from "@/components/lead/useLeadWorkspaceShellFirefly";
import { useFireflyDisplayMode } from "@/hooks/useFireflyDisplayMode";
import { shouldShowFloatingFireflyHost } from "@/lib/firefly/sidebarFireflyDockGlow";
import { FireflySidebarDockTravelHost } from "@/components/activity/firefly/FireflySidebarDockTravelHost";
import { MessengerShellHost } from "@/components/shell/MessengerShellHost";

type FireflyState = ReturnType<typeof useLeadWorkspaceShellFirefly>;

export function LeadWorkspaceShellFireflyOverlay(props: {
  mode: PrimaryMode;
  firefly: FireflyState;
}) {
  const { mode, firefly } = props;
  const {
    fireflyAskHighlight,
    setFireflyAskHighlight,
    assistLevel,
    discoveryConfig,
    discoveryArtifact,
    dismissDiscoverySession,
    tourSession,
    showDiscoveryOffer,
  } = firefly;
  const { mode: fireflyDisplayMode } = useFireflyDisplayMode();
  const showFloatingHost = shouldShowFloatingFireflyHost(fireflyDisplayMode);

  return (
    <>
      <FireflyTourSessionLayer session={tourSession} />
      <FireflySidebarDockTravelHost />
      <MessengerShellHost />
      {showFloatingHost ? (
        <FireflyDiscoveryTourOffer
          tourId={discoveryConfig?.tourId ?? ""}
          title={discoveryConfig?.title ?? ""}
          body={discoveryConfig?.body ?? ""}
          visible={showDiscoveryOffer}
          onAccept={() => {
            if (!discoveryArtifact || !discoveryConfig) return;
            dismissDiscoverySession(discoveryConfig.tourId);
            setFireflyAskHighlight(null);
            emitFireflyTourRequestEvent(
              buildFireflyTourRequestEventDetail({
                tourId: discoveryArtifact.id,
                trigger: "discovery",
                intent: "discovery",
                mode,
                targetMode: discoveryArtifact.steps[0]?.target.mode ?? mode,
                outcome: "started",
                assistLevel,
                nowMs: Date.now(),
              })
            );
            tourSession.startTour(discoveryArtifact, "discovery");
          }}
          onDismiss={() => {
            if (discoveryConfig) dismissDiscoverySession(discoveryConfig.tourId);
          }}
        />
      ) : null}
      {showFloatingHost && !tourSession.isActive ? (
        <FireflyTargetHighlightHost
          targetId={fireflyAskHighlight?.targetId ?? null}
          callout={fireflyAskHighlight?.callout}
          onDismiss={() => setFireflyAskHighlight(null)}
        />
      ) : null}
    </>
  );
}
